let $ : any;
(function($s) {
$ = $s;
})(globalThis.window["jQuery"]);
export { $ };